import React from "react";
import type { Clarification } from "../../types/clarification.type";
import { formatClarificationRef } from "../../utils/formatClarificationRef";
import { truncateHtml } from "helpers/stringHelper";

interface ClarificationSendListProps {
	clarifications: Clarification[];
	/**
	 * Truncation length for the clarification text. When omitted, defaults to
	 * 100 characters for short lists (<=3) and 80 characters for longer lists.
	 */
	maxLength?: number;
}

const truncateText = (text: string, maxLength: number): string => {
	if (!text) {
		return "";
	}
	return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const ClarificationSendList: React.FC<ClarificationSendListProps> = ({
	clarifications,
	maxLength,
}) => {
	const isLongList = clarifications.length > 3;
	const effectiveMaxLength = maxLength ?? (isLongList ? 80 : 100);

	const containerClass = isLongList
		? "max-h-40 space-y-2 overflow-y-auto"
		: "space-y-2";

	return (
		<div className={containerClass}>
			{clarifications.map((clarification) => (
				<div key={clarification.id} className="text-sm text-gray-600">
					<span className="font-medium">{formatClarificationRef(clarification.supplier_name, clarification.reference_number)}:</span>{" "}
					<span dangerouslySetInnerHTML={{ __html: truncateHtml(clarification.clarification_text, { maxCharacters: effectiveMaxLength, maxLines: 3 }).value }}></span>
				</div>
			))}
		</div>
	);
};
